import BackendService from '@/services/Backend'

class ValidationService extends BackendService {
  constructor (baseUrl, interceptor) {
    super(baseUrl, '/validations/v1', interceptor)
  }

  validatePhoneNumber (phoneNumber) {
    return this.get('phone-number/phone-info', {
      phoneNumber
    })
  }
}

export default ValidationService
